import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import CommentThread from '../../../CommentThread';
import ErrorBoundary from '../../../ErrorBoundary';
import DisabledComment from '../../../DisabledComment';
import { getCommentableTypeForDeviationType } from '../../redux/helpers';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import Premium from '@wix/da-ds/pkg/Icons/24x24/Premium';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/16x16/EyeDisc2';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { isImageDeviation } from '../../../DeviationViews/_helpers';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import DesktopComments728x90 from '@wix/da-ads/pkg/adunits/DesktopComments728x90';
import { getCurrentAdSafety } from '../../../Ads/redux/selectors';
import { useSelector } from 'react-redux';
import s from './Comments.scss';
export const COMMENTS_HTML_ID = 'comments';
export const Comments = ({ deviation: { deviationId , typeId , isCommentable , hasPrivateComments  } , deviation , isOwner , className  })=>{
    const { t  } = useTranslation();
    const { isLoggedIn  } = useContext(SessionContext);
    const noAnonComments = useFlag('no_anon_comments');
    const adSaftey = useSelector((state)=>getCurrentAdSafety(state));
    // Comments are never shown to anon users T58757
    if (!isLoggedIn && noAnonComments) {
        return /*#__PURE__*/ React.createElement(DesktopComments728x90, {
            safety: adSaftey
        });
    }
    const commentableTypeId = getCommentableTypeForDeviationType(typeId);
    const { isPremium , isPaidFolder  } = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData);
    const ownerInfo = isOwner && isPremium && hasPrivateComments && /*#__PURE__*/ React.createElement("div", {
        className: s['owner-info-wrapper']
    }, isPaidFolder ? /*#__PURE__*/ React.createElement(Premium, {
        size: IconSize.TINY
    }) : /*#__PURE__*/ React.createElement(EyeDisc2, {
        size: IconSize.TINY
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['owner-info']
    }, t(isPaidFolder ? 'deviation.comments.paywallOwner.premium' : 'deviation.comments.paywallOwner.watchers_only')));
    const withCommentSuggestions = isImageDeviation(deviation) && !isOwner ? 'deviation' : undefined;
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "Comments"
    }, /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            sectionname: 'comments'
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['comments-anchor'],
        id: COMMENTS_HTML_ID
    }), /*#__PURE__*/ React.createElement(CommentThread, {
        key: `${commentableTypeId}:${deviationId}`,
        commentableTypeId: commentableTypeId,
        commentableItemId: deviationId,
        postbox: isCommentable ? 'both' : 'none',
        statsAndControls: "on",
        className: className,
        allowSelfInit: false,
        enableOffsetTracking: true,
        extraInHeader: ownerInfo,
        withCommentSuggestions: withCommentSuggestions,
        isSticky: true,
        withAd: true
    }), !isCommentable && /*#__PURE__*/ React.createElement(DisabledComment, {
        className: classnames(s['comments-disabled'], className),
        title: t('deviation.comments.commentsDisabled')
    })));
};
Comments.displayName = 'Comments';
export default Comments;
